// React
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// Components
import Home from './components/pages/home.component.jsx';
import Winners from './components/pages/winners.component.jsx';
import Regulation from './components/pages/regulation.component.jsx';
import Help from './components/pages/help.component.jsx';
import Ticket from './components/pages/ticket.component.jsx';
import GamePage from './components/pages/gamePage.component.jsx';
import Error from './components/pages/error.component.jsx';

// Rendering
class appRouter extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        {/*Pages*/}
        <Route component={Home} path="(/m)?/home"/>
        <Route component={Winners} path="(/m)?/winners"/>
        <Route component={Regulation} path="(/m)?/regulation"/>
        <Route component={Help} path="(/m)?/help"/>
        <Route component={Ticket} path="(/m)?/tickets"/>
        <Route component={GamePage} path="(/m)?/game"/>

        {/*Redirects*/}
        <Route exact path="(/m)?/" render={() => <Redirect to="/home" component={Home} />} />

        {/*ErrorPage*/}
        <Route push path="*" component={Error} />
      </Switch>
    );
  }
}

export default appRouter;


// WEBPACK FOOTER //
// ./src/router.jsx